import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { Flame } from 'lucide-react';
import { NoahMascot } from './NoahMascot';
import { InfoTip } from './InfoTip';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useStreak = () => {
  const [streak, setStreak] = useState(null);
  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/deals/streak`);
      setStreak(data);
      return data;
    } catch {
      return null;
    }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  return { streak, refresh };
};

/** Racha de cierres: Noah celebra cuando cierras ventas seguidas. */
export const StreakCard = ({ testId = 'streak-card' }) => {
  const { streak } = useStreak();
  if (!streak || streak.streak < 1) return null;

  const hot = streak.streak >= 3;

  return (
    <div
      data-testid={testId}
      className={`relative flex items-center gap-3 p-4 rounded-3xl ${hot ? 'bg-brand-deep' : 'bg-brand-mint dark:bg-brand-deep'}`}
    >
      {hot && <NoahMascot mood="happy" size={64} className="shrink-0 -my-2" />}
      <div className="min-w-0 flex-1">
        <p className={`text-xs font-semibold flex items-center gap-1.5 ${hot ? 'text-brand-butter' : 'text-brand-deep dark:text-brand-butter'}`}>
          <Flame className="w-3.5 h-3.5" />
          {hot ? `¡Racha de ${streak.streak} cierres!` : `Racha en marcha: ${streak.streak} cierre${streak.streak > 1 ? 's' : ''}`}
          <InfoTip
            title="Racha de cierres"
            text="Ventas ganadas una detrás de otra sin ningún negocio perdido en medio. Se corta en cuanto marcas un cliente como perdido."
            source="Etapa de tus clientes ordenada por fecha de actualización"
            to="/deals"
            linkLabel="Ver ventas"
            testId="streak-info"
          />
        </p>
        <p className={`text-[11px] mt-0.5 ${hot ? 'text-white/80' : 'text-brand-deep/70 dark:text-white/80'}`}>
          ${Number(streak.streak_value || 0).toLocaleString()} cerrados seguidos · mejor racha: {streak.best_streak}
        </p>
        {streak.names?.length > 0 && (
          <p className={`text-[11px] truncate ${hot ? 'text-white/60' : 'text-brand-deep/60 dark:text-white/60'}`}>
            {streak.names.filter(Boolean).slice(0, 3).join(' · ')}
          </p>
        )}
      </div>
    </div>
  );
};

export default StreakCard;
